module.exports = __webpack_public_path__ + "img/statistics.973cf358.png";